import type { FC } from 'react';
import React, { memo } from 'react';
import './index.scss';
import { twcls } from '@utils/twcls';

interface OrderListItemStatusProps {
  itemStatusId: number | string;
  className?: string;
}

const OrderListItemStatus: FC<OrderListItemStatusProps> = ({
  itemStatusId,
  className
}) => {
  let status = {
    title: 'Неизвестно',
    color: 'yellow'
  };
  switch (itemStatusId) {
    case 16:
    case 2:
      status = {
        title: 'Новый',
        color: 'red'
      };
      break;
    case 3:
      status = {
        title: 'Принят',
        color: 'light-blue'
      };
      break;
    case 4:
      status = {
        title: 'В сборке',
        color: 'yellow'
      };
      break;
    case 9:
      status = {
        title: 'Отменен',
        color: 'black'
      };
      break;
    case 6:
      status = {
        title: 'Завершен',
        color: 'green'
      };
      break;
    case 10:
      status = {
        title: 'Изменен клиентом',
        color: 'darkRed'
      };
      break;
    case 11:
      status = {
        title: 'Доставлен',
        color: 'green'
      };
      break;
    case 13:
      status = {
        title: 'Готов к выдаче',
        color: 'yellow'
      };
      break;
    case 5:
      status = {
        title: 'В пути',
        color: 'orange'
      };
      break;
    case 'edit':
      status = {
        title: 'Редактирование',
        color: 'salmon-light'
      };
      break;
    case 'isDigital':
      status = {
        title: 'Цифровой товар',
        color: 'violet'
      };
      break;
    default:
      break;
  }
  return (
    <div
      className={twcls(`order-status order-status--${status.color}`, className)}
    >
      {status.title}
    </div>
  );
};

export default memo(OrderListItemStatus);
